import { useTransparencyBalances } from '../../hooks/useTransparency'
import useVestingContractData from '../../hooks/useVestingContractData'

import SectionParagraph from './SectionParagraph'
import SectionTitle from './SectionTitle'
import './Treasury.css'

const DAO_VESTING_CONTRACT_ADDRESS = '0x7a3abf8897f31b56f09c6f69d074a393a905c1ac'

const numberFormat = Intl.NumberFormat('en')

export default function Treasury() {
  const { data: balancesData } = useTransparencyBalances()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const treasuryAmount = balancesData?.reduce((acc, item) => {
    return acc + item.amount * item.rate
  }, 0)

  const { vestingData } = useVestingContractData([DAO_VESTING_CONTRACT_ADDRESS])
  const { releasable, released, total } = vestingData?.[0] || {}
  const vested = releasable && released ? releasable + released : undefined
  const releasedPercentage = (100 * releasable!) / total!
  const vestedPercentage = (100 * vested!) / total!
  console.log({ vested, releasedPercentage, vestedPercentage, released, total })

  return (
    <div className="Home__Card Treasury">
      <div className="Home__CardContainer">
        <SectionTitle linkText="See Full Report" linkHref="https://decentraland.org/governance/transparency">
          DAO Treasury
        </SectionTitle>
        <SectionParagraph>
          The DAO has been granted a 10-year vesting contract worth <strong>222,000,000 MANA.</strong> We use these
          funds to sponsor the growth of the Decentraland platform through community projects.
        </SectionParagraph>
        <div className="Treasury__VestingContract Treasury__VestingContractTotals">
          <span className="Treasury__VestingContractTitle">Vesting Contract</span>
          <div className="Treasury__VestingContractBar">
            <div className="Treasury__VestingContractVestedBar" style={{ width: `${vestedPercentage}%` }} />
            <div className="Treasury__VestingContractReleasedBar" style={{ width: `${releasedPercentage}%` }} />
          </div>
          <div className="Treasury__VestingContractLegends">
            <div className="Treasury_VestingContractLegend">Released</div>
            <div className="Treasury_VestingContractLegend">
              <div className="Treasury__VestingContractVestedDot" />
              Vested
            </div>
            <div className="Treasury_VestingContractLegend">
              <div className="Treasury__VestingContractTotalDot" />
              Total
            </div>
          </div>
        </div>
        <div className="Treasury__VestingContract">
          <span className="Treasury__VestingContractTitle Treasury__DAOTreasuryTitle">DAO Treasury</span>
          <div className="Treasury__Total">${numberFormat.format(Math.round(treasuryAmount ?? 0))}</div>
        </div>
      </div>
    </div>
  )
}
